import { Link, useIntl } from 'gatsby-plugin-intl'
import React from 'react'
import Layout from '../../components/Layout/index'
import PressRelease from '../../components/PressRelease'
import SEO from '../../components/seo'
import Footer from '../../modules/Footer'
import Header from '../../modules/Header'

import Image from '../../images/news/press-release-etravel.png'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import messages from '../../messages/pageTitles.lang'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNewsEtravel)}
        imageAlt={formatMessage(messages.TitleNewsEtravel)}
        description={formatMessage(metaDescription.NewsEtravelDescription)}
        image={Image}
        lang={locale}
      />
      <PressRelease
        article={newsList.etravel}
        articleLinks={{
          services: <Link to="/services/">{`https://www.freshcells.de/${locale}/services/`}</Link>
        }}
      />
    </Layout>
  )
}

export default IndexPage
